import request from '@/utils/request';

export default {
	list:(query)=>request({
		url: '/feedback-questions',
		method: 'get',
		params: query
	})
}
